import type { Actions } from '@utilities-one/api-sdk';

import { interceptActions } from './interceptActions';
import { proxy } from './proxy';

export const actions = interceptActions<Actions>({} as Actions, ({ entity, method, args }) => {
  return proxy({ entity: entity as string, method, args });
});
